export default {
  NORA: {
    baseUrl: {
      DEV: 'https://d3bp57v33hncyl.cloudfront.net',
      QA: 'https://d1yii8p56p78hz.cloudfront.net',
      PREPROD: 'https://d2ja1t4z0bvzku.cloudfront.net',
      PROD: 'https://d3fwuswwhi7ss1.cloudfront.net'
    },
    apiDomain: {
      DEV: 'https://tnf-staging.demostellar.com',
      QA: 'https://tnf-qa.demostellar.com',
      PREPROD: 'https://tnf-qa.demostellar.com',
      PROD: 'https://tnf.runstellar.com'
    },
    cssUrl: '/tnfcanvasnora/tnfcanvasnora-webapp.style.css',
    jsUrl: '/loyalty-webapp.bundle.js',
    configUrl: '/tnfcanvasnora/app-config.json'
  },
  EMEA: {
    baseUrl: {
      DEV: 'https://ds8s3etqpk8ol.cloudfront.net',
      QA: 'https://d27vi88kv3kei4.cloudfront.net',
      PREPROD: 'https://dghi27fisgxty.cloudfront.net',
      PROD: 'https://d3kvd9ktmn6p4t.cloudfront.net'
    },
    apiDomain: {
      DEV: 'https://tnfemea-staging.demostellar.com',
      QA: 'https://tnfemea-staging.demostellar.com',
      PREPROD: 'https://tnfemea-staging.demostellar.com',
      PROD: 'https://tnfemea.runstellar.com'
    },
    cssUrl: '/tnfcanvasemea/tnfcanvasemea-webapp.style.css',
    jsUrl: '/loyalty-webapp.bundle.js',
    configUrl: '/tnfcanvasemea/app-config.json'
  }
}
